import { Expression, SqlOptions } from '../types';
import compileExpressions from './filter-builder/compile-expressions';
import convertRecordFilters from './filter-builder/convert-record-filters';
import formatExpression from './filter-builder/format-expression';

export interface TypedExpressions {
  type: 'and' | 'or'
  expressions: (Expression | TypedExpressions)[]
}

export default function filterBuilder(
  sqlOptions: SqlOptions,
): TypedExpressions | null {
  const expressions: Expression[] = [];

  const { recordFilters, additionalFilters } = sqlOptions;

  const processExpression = (expression: Expression) => {
    const formattedExpression = formatExpression(sqlOptions, expression);
    if (formattedExpression) {
      expressions.push(formattedExpression);
    }
  };

  if (recordFilters?.filters?.length) {
    const recordFilterExpressions = convertRecordFilters(recordFilters.filters);
    recordFilterExpressions.forEach((expression) => processExpression(expression));
  }

  if (additionalFilters?.length) {
    additionalFilters.forEach((expression) => processExpression(expression));
  }

  if (!expressions.length) {
    return null;
  }
  return compileExpressions(expressions);
}
